export const environment = {
  production: false,
  apiUrl: 'https://api.dev.consultorio.biz/api/v1/public',
  // apiUrl: 'http://localhost:8000/api/v1/public',
};
